// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let React = require("react");
let Loader = require("../common/Components/Loader.bs.js");
let ButtonsV5 = require("../common/Components/ButtonsV5.bs.js");
let Form__Label = require("../common/Components/Form__Label.bs.js");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let ReasonPromise = require("../../reason/ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let AvatarUploadProvider = require("../../reason/settings/components/AvatarUploadProvider.bs.js");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SelectProfilePhotoButton = require("../common/Components/SelectProfilePhotoButton.bs.js");
let TeamMarketingProfileLogoForm_RemoveMutation_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_RemoveMutation_graphql.bs.js");
let TeamMarketingProfileLogoForm_UpdateMutation_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_UpdateMutation_graphql.bs.js");
let TeamMarketingProfileLogoForm_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.bs.js");

let convertFragment = TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertVariables;

let convertResponse = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, TeamMarketingProfileLogoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, TeamMarketingProfileLogoForm_UpdateMutation_graphql.node, convertResponse, convertWrapRawResponse);

let UpdateMutation_imageContentType_decode = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Utils.imageContentType_decode;

let UpdateMutation_imageContentType_fromString = TeamMarketingProfileLogoForm_UpdateMutation_graphql.Utils.imageContentType_fromString;

let UpdateMutation = {
  imageContentType_decode: UpdateMutation_imageContentType_decode,
  imageContentType_fromString: UpdateMutation_imageContentType_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

let convertVariables$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertVariables;

let convertResponse$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = TeamMarketingProfileLogoForm_RemoveMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation$1 = RescriptRelay_Mutation.commitMutation(convertVariables$1, TeamMarketingProfileLogoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, TeamMarketingProfileLogoForm_RemoveMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let RemoveMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation$1,
  use: use$2
};

let acceptedImageTypes = [
  "JPEG",
  "GIF",
  "PNG",
  "WEBP"
];

function TeamMarketingProfileLogoForm$WithoutErrorBoundary(props) {
  let marketingProfile = RescriptRelay_Fragment.useFragment(TeamMarketingProfileLogoForm_teamMarketingProfile_graphql.node, convertFragment, props.teamMarketingProfile);
  let match = React.useState(() => "InitialState");
  let setState = match[1];
  let state = match[0];
  let match$1 = use$1();
  let runUpdateMutation = match$1[0];
  let match$2 = use$2();
  let runRemoveMutation = match$2[0];
  let upload = AvatarUploadProvider.useUpload();
  let onSelectImage = file => {
    setState(param => "Saving");
    let dataUrl = URL.createObjectURL(file);
    ReasonPromise.get(upload(dataUrl), upload => {
      if (upload.TAG === "Ok") {
        let match = upload._0;
        let contentType = SelectProfilePhotoButton.ImageMimeType.parse(match.contentType);
        if (contentType.TAG === "Ok") {
          let contentType$1 = contentType._0;
          runUpdateMutation({
            input: {
              logo: {
                contentType: contentType$1 === "PNG" ? "PNG" : (
                    contentType$1 === "JPEG" ? "JPEG" : (
                        contentType$1 === "WEBP" ? "WEBP" : "GIF"
                      )
                  ),
                fileName: match.fileName,
                id: match.id,
                key: match.key
              }
            }
          }, undefined, undefined, undefined, (response, errors) => {
            let match = response.updateTeamMarketingProfileLogo;
            if (match !== undefined) {
              switch (match.__typename) {
                case "ProfileSettingsChangedError" :
                  let settingsChangedMessage = match.settingsChangedMessage;
                  return setState(param => ({
                    TAG: "Error",
                    _0: {
                      TAG: "SettingsChanged",
                      _0: settingsChangedMessage
                    }
                  }));
                case "TeamMarketingProfileLogoUpdated" :
                  if (errors === undefined) {
                    return setState(param => "InitialState");
                  }
                  break;
                case "__unselected" :
                  break;
              }
            }
            setState(param => ({
              TAG: "Error",
              _0: "UploadError"
            }));
          }, _error => setState(param => ({
            TAG: "Error",
            _0: "UploadError"
          })), undefined);
        } else {
          let s = contentType._0.VAL;
          setState(param => ({
            TAG: "Error",
            _0: {
              TAG: "UnsupportedMimeType",
              _0: s
            }
          }));
        }
      } else {
        setState(param => ({
          TAG: "Error",
          _0: "UploadError"
        }));
      }
      URL.revokeObjectURL(dataUrl);
    });
  };
  let onRemoveLogo = () => {
    setState(param => "Saving");
    runRemoveMutation(undefined, undefined, undefined, undefined, (response, errors) => {
      let match = response.removeTeamMarketingProfileLogo;
      if (match !== undefined) {
        switch (match.__typename) {
          case "ProfileSettingsChangedError" :
            let settingsChangedMessage = match.settingsChangedMessage;
            return setState(param => ({
              TAG: "Error",
              _0: {
                TAG: "SettingsChanged",
                _0: settingsChangedMessage
              }
            }));
          case "TeamMarketingProfileLogoRemoved" :
            if (errors === undefined) {
              return setState(param => "InitialState");
            }
            break;
          case "__unselected" :
            break;
        }
      }
      setState(param => ({
        TAG: "Error",
        _0: "RemovePhotoError"
      }));
    }, _error => setState(param => ({
      TAG: "Error",
      _0: "RemovePhotoError"
    })), undefined);
  };
  let tmp;
  let exit = 0;
  if (typeof state !== "object" && state !== "InitialState") {
    tmp = JsxRuntime.jsx(Loader.make, {});
  } else {
    exit = 1;
  }
  if (exit === 1) {
    let tmp$1;
    if (typeof state !== "object") {
      tmp$1 = null;
    } else {
      let message = state._0;
      tmp$1 = typeof message !== "object" ? (
          message === "UploadError" ? JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error updating your image. Please try again."
            }) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "There was an error removing your logo. Please try again."
            })
        ) : (
          message.TAG === "SettingsChanged" ? JsxRuntime.jsx(Alert.$$Error.make, {
              title: Stdlib_Option.getOr(message._0, "Your profile settings have changed. Refresh this page before saving.")
            }) : JsxRuntime.jsx(Alert.$$Error.make, {
              title: "The selected image format is not supported."
            })
        );
    }
    let logo = marketingProfile.logo;
    tmp = JsxRuntime.jsxs("div", {
      children: [
        tmp$1,
        logo !== undefined ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Next__Image.make, {
                  src: logo.url,
                  width: 96,
                  height: 96,
                  unoptimized: true,
                  alt: "Your current logo",
                  className: "w-24 h-24 rounded-md object-contain"
                }),
                className: "border border-zinc-200 p-1 rounded-md"
              }),
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(SelectProfilePhotoButton.make, {
                    onSelectProfilePhoto: onSelectImage,
                    acceptedImageTypes: acceptedImageTypes,
                    children: "Change logo"
                  }),
                  JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: param => onRemoveLogo(),
                    size: "small",
                    children: "Remove logo"
                  })
                ],
                className: "flex flex-col gap-4 items-start md:items-center lg:items-start"
              })
            ],
            className: "flex gap-4 md:items-center lg:items-start md:flex-col lg:flex-row"
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(SelectProfilePhotoButton.make, {
              onSelectProfilePhoto: onSelectImage,
              acceptedImageTypes: acceptedImageTypes,
              children: "Upload"
            })
          })
      ],
      className: "flex flex-col gap-4"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Form__Label.make, {
              labelText: "Logo"
            }),
            JsxRuntime.jsx("small", {
              children: "Upload a logo to display at the top of your marketing profile next to your team name.\n",
              className: "text-base text-zinc-500"
            })
          ]
        }),
        className: "pt-2 col-span-2"
      }),
      JsxRuntime.jsx("div", {
        children: tmp,
        className: "mt-2 sm:col-span-3 sm:mt-0 "
      })
    ],
    className: "sm:grid sm:grid-cols-5 sm:items-start gap-16 py-6 space-y-6"
  });
}

let WithoutErrorBoundary = {
  make: TeamMarketingProfileLogoForm$WithoutErrorBoundary
};

function TeamMarketingProfileLogoForm(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Team logo",
    children: JsxRuntime.jsx(TeamMarketingProfileLogoForm$WithoutErrorBoundary, {
      teamMarketingProfile: props.teamMarketingProfile
    })
  });
}

let make = TeamMarketingProfileLogoForm;

exports.Fragment = Fragment;
exports.UpdateMutation = UpdateMutation;
exports.RemoveMutation = RemoveMutation;
exports.acceptedImageTypes = acceptedImageTypes;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
